import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { useNavigate } from 'react-router-dom';

const API = 'https://bacmt.com.ar';
/*const API = 'http://192.168.2.25:3000';*/
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

function AdminEmpresa() {
    const navigate = useNavigate();
    const [tab, setTab] = useState('operadores');
    return (
        <div style={s.page}>
            <Navbar />
            <div style={s.contenido}>
                <div style={s.header}>
                    <div>
                        <p style={s.headerSub}>PANEL EMPRESA</p>
                        <h2 style={s.headerTitulo}>Gestión de mi empresa</h2>
                    </div>
                    <button style={s.btnVolver} onClick={() => navigate('/dashboard')}>← Dashboard</button>
                </div>
                <div style={s.tabs}>
                    {[
                        { id: 'operadores', label: '👤 Operadores' },
                        { id: 'equipos',    label: '📡 Mis equipos' },
                    ].map(t => (
                        <button key={t.id}
                            style={{ ...s.tab, ...(tab===t.id ? s.tabActivo : {}) }}
                            onClick={() => setTab(t.id)}>
                            {t.label}
                        </button>
                    ))}
                </div>
                {tab === 'operadores' && <TabOperadores />}
                {tab === 'equipos'    && <TabEquiposEmpresa />}
            </div>
        </div>
    );
}

// ── TAB OPERADORES ─────────────────────────────────────────
function TabOperadores() {
    const [operadores, setOperadores] = useState([]);
    const [form, setForm] = useState({ nombre: '', email: '', password: '' });
    const [editando, setEditando] = useState(null);
    const [msg, setMsg] = useState(''); const [err, setErr] = useState(''); const [cargando, setCargando] = useState(false);

    const traer = useCallback(async () => {
        try { const r = await axios.get(`${API}/api/empresa/operadores`, { headers: headers() }); setOperadores(r.data); }
        catch { setErr('Error cargando operadores'); }
    }, []);

    useEffect(() => { traer(); }, [traer]);

    const crear = async (e) => {
        e.preventDefault(); setMsg(''); setErr(''); setCargando(true);
        try {
            await axios.post(`${API}/api/empresa/operadores`, form, { headers: headers() });
            setMsg(`Operador ${form.email} creado. Se envió mail de bienvenida.`);
            setForm({ nombre: '', email: '', password: '' });
            traer();
        } catch (error) { setErr(error.response?.data?.error || 'Error al crear'); }
        finally { setCargando(false); }
    };

    const editar = async (e) => {
        e.preventDefault(); setMsg(''); setErr(''); setCargando(true);
        try {
            await axios.put(`${API}/api/empresa/operadores/${editando.id}`,
                { nombre: editando.nombre, email: editando.email }, { headers: headers() });
            setMsg('Operador actualizado');
            setEditando(null);
            traer();
        } catch (error) { setErr(error.response?.data?.error || 'Error al actualizar'); }
        finally { setCargando(false); }
    };

    const toggleEstado = async (id, activo) => {
        try { await axios.post(`${API}/api/empresa/operadores/${id}/estado`, { activo: !activo }, { headers: headers() }); traer(); }
        catch { setErr('Error al cambiar estado'); }
    };

    const eliminar = async (id, nombre) => {
        if (!window.confirm(`¿Eliminar al operador ${nombre}?`)) return;
        try { await axios.delete(`${API}/api/empresa/operadores/${id}`, { headers: headers() }); setMsg('Operador eliminado'); traer(); }
        catch { setErr('Error al eliminar'); }
    };

    return (
        <div style={s.tabContent}>
            {/* Formulario crear */}
            <div style={s.card}>
                <p style={s.cardTitulo}>Nuevo operador</p>
                <p style={s.cardDesc}>Los operadores pueden ver los registros de los equipos de tu empresa pero no gestionar usuarios.</p>
                <form onSubmit={crear} style={s.form}>
                    <div style={s.formRow}>
                        <div style={s.campo}>
                            <label style={s.label}>Nombre *</label>
                            <input style={s.input} value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Nombre completo" required />
                        </div>
                        <div style={s.campo}>
                            <label style={s.label}>Email *</label>
                            <input style={s.input} type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="operador@empresa.com" required />
                        </div>
                        <div style={s.campo}>
                            <label style={s.label}>Contraseña inicial *</label>
                            <input style={s.input} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Mínimo 6 caracteres" required />
                        </div>
                        <button type="submit" style={s.btnPrimario} disabled={cargando}>{cargando ? 'Creando...' : '+ Agregar'}</button>
                    </div>
                    {msg && <div style={s.successBox}>✓ {msg}</div>}
                    {err && <div style={s.errorBox}>⚠ {err}</div>}
                </form>
            </div>

            {/* Formulario editar */}
            {editando && (
                <div style={{ ...s.card, borderColor: 'var(--accent)' }}>
                    <p style={s.cardTitulo}>Editando: {editando.email}</p>
                    <form onSubmit={editar} style={s.form}>
                        <div style={s.formRow}>
                            <div style={s.campo}>
                                <label style={s.label}>Nombre</label>
                                <input style={s.input} value={editando.nombre} onChange={e => setEditando({...editando, nombre: e.target.value})} required />
                            </div>
                            <div style={s.campo}>
                                <label style={s.label}>Email</label>
                                <input style={s.input} type="email" value={editando.email} onChange={e => setEditando({...editando, email: e.target.value})} required />
                            </div>
                            <button type="submit" style={s.btnPrimario} disabled={cargando}>Guardar cambios</button>
                            <button type="button" style={s.btnVolver} onClick={() => setEditando(null)}>Cancelar</button>
                        </div>
                    </form>
                </div>
            )}

            {/* Tabla operadores */}
            <div style={s.tablaWrap}>
                <div style={s.tablaHeader}><span style={s.tablaCount}>{operadores.length} operadores</span></div>
                <table style={s.tabla}>
                    <thead><tr>{['ID','Nombre','Email','Estado','Alta','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                    <tbody>
                        {operadores.length === 0
                            ? <tr><td colSpan="6" style={s.tdVacio}>No hay operadores creados todavía.</td></tr>
                            : operadores.map(op => (
                                <tr key={op.id}>
                                    <td style={{...s.td,...s.tdMono}}>#{op.id}</td>
                                    <td style={{...s.td,fontWeight:'500'}}>{op.nombre}</td>
                                    <td style={{...s.td,...s.tdMono,fontSize:'0.78rem'}}>{op.email}</td>
                                    <td style={s.td}><span style={{...s.pill,...(op.activo?s.pillVerde:s.pillRojo)}}>{op.activo?'Activo':'Inactivo'}</span></td>
                                    <td style={{...s.td,...s.tdMono,fontSize:'0.76rem'}}>{new Date(op.fecha_creacion).toLocaleDateString()}</td>
                                    <td style={{...s.td,display:'flex',gap:'6px'}}>
                                        <button style={{...s.btnAccion,backgroundColor:'rgba(47,127,255,0.08)',color:'var(--accent)',borderColor:'rgba(47,127,255,0.25)'}}
                                            onClick={() => setEditando(op)}>
                                            Editar
                                        </button>
                                        <button style={{...s.btnAccion,...(op.activo?s.btnDesactivar:s.btnActivar)}}
                                            onClick={() => toggleEstado(op.id, op.activo)}>
                                            {op.activo ? 'Desactivar' : 'Activar'}
                                        </button>
                                        <button style={{...s.btnAccion,backgroundColor:'rgba(240,77,94,0.08)',color:'var(--danger)',borderColor:'rgba(240,77,94,0.25)'}}
                                            onClick={() => eliminar(op.id, op.nombre)}>
                                            Eliminar
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

// ── TAB EQUIPOS EMPRESA ────────────────────────────────────
// El admin_empresa SOLO puede editar la descripción del equipo.
// La serie, num_interno y zona horaria las gestiona el superadmin (ocultas acá).
function TabEquiposEmpresa() {
    const [equipos, setEquipos] = useState([]);
    const [editando, setEditando] = useState(null); // { id, serie, descripcion }
    const [msg, setMsg] = useState(''); const [err, setErr] = useState(''); const [cargando, setCargando] = useState(false);

    const traer = useCallback(async () => {
        try { const r = await axios.get(`${API}/api/mis-equipos`, { headers: headers() }); setEquipos(r.data); }
        catch (e) { console.error(e); setErr('Error cargando equipos'); }
    }, []);

    useEffect(() => { traer(); }, [traer]);

    const guardar = async (e) => {
        e.preventDefault(); setMsg(''); setErr(''); setCargando(true);
        try {
            // Solo se envía la descripción. El back valida que el equipo sea de la empresa del usuario.
            await axios.put(`${API}/api/empresa/equipos/${editando.id}`,
                { descripcion: editando.descripcion }, { headers: headers() });
            setMsg('Descripción actualizada');
            setEditando(null);
            traer();
        } catch (error) { setErr(error.response?.data?.error || 'Error al actualizar'); }
        finally { setCargando(false); }
    };

    return (
        <div style={s.tabContent}>
            {/* Formulario editar descripción */}
            {editando && (
                <div style={{ ...s.card, borderColor: 'var(--accent)' }}>
                    <p style={s.cardTitulo}>Editando equipo: {editando.serie}</p>
                    <p style={s.cardDesc}>Podés cambiar la descripción del equipo. La serie y el número interno los gestiona el administrador general.</p>
                    <form onSubmit={guardar} style={s.form}>
                        <div style={s.formRow}>
                            <div style={s.campo}>
                                <label style={s.label}>Descripción</label>
                                <input
                                    style={s.input}
                                    value={editando.descripcion || ''}
                                    onChange={e => setEditando({ ...editando, descripcion: e.target.value })}
                                    placeholder="Ej: Generador sala 2"
                                    autoFocus
                                />
                            </div>
                            <button type="submit" style={s.btnPrimario} disabled={cargando}>{cargando ? 'Guardando...' : 'Guardar cambios'}</button>
                            <button type="button" style={s.btnVolver} onClick={() => setEditando(null)}>Cancelar</button>
                        </div>
                    </form>
                </div>
            )}

            <div style={s.tablaWrap}>
                <div style={s.tablaHeader}>
                    <span style={s.tablaCount}>{equipos.length} equipos asignados a tu empresa</span>
                </div>
                {msg && <div style={{ ...s.successBox, margin: '12px 20px 0' }}>✓ {msg}</div>}
                {err && <div style={{ ...s.errorBox, margin: '12px 20px 0' }}>⚠ {err}</div>}
                <table style={s.tabla}>
                    <thead><tr>{['ID','Serie','num_interno','Descripción','Estado','Alta','Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
                    <tbody>
                        {equipos.length === 0
                            ? <tr><td colSpan="7" style={s.tdVacio}>No hay equipos asignados a tu empresa.</td></tr>
                            : equipos.map(eq => (
                                <tr key={eq.id}>
                                    <td style={{...s.td,...s.tdMono}}>#{eq.id}</td>
                                    <td style={{...s.td,...s.tdMono}}>{eq.serie}</td>
                                    <td style={{...s.td,...s.tdMono}}>{eq.num_interno || '—'}</td>
                                    <td style={s.td}>{eq.descripcion || '—'}</td>
                                    <td style={s.td}><span style={{...s.pill,...(eq.estado==='activo'?s.pillVerde:s.pillRojo)}}>{eq.estado}</span></td>
                                    <td style={{...s.td,...s.tdMono,fontSize:'0.76rem'}}>{new Date(eq.fecha_alta).toLocaleDateString()}</td>
                                    <td style={s.td}>
                                        <button
                                            style={{...s.btnAccion,backgroundColor:'rgba(47,127,255,0.08)',color:'var(--accent)',borderColor:'rgba(47,127,255,0.25)'}}
                                            onClick={() => setEditando({ id: eq.id, serie: eq.serie, descripcion: eq.descripcion || '' })}>
                                            Editar
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const s = {
    page: { minHeight:'100vh', backgroundColor:'var(--bg-base)' },
    contenido: { padding:'28px 36px', maxWidth:'1200px', margin:'0 auto' },
    header: { display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:'24px' },
    headerSub: { fontSize:'0.7rem', color:'var(--accent)', letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:'6px' },
    headerTitulo: { fontSize:'1.5rem', fontWeight:'600', color:'var(--text-primary)', letterSpacing:'-0.02em' },
    btnVolver: { background:'none', border:'1px solid var(--border-light)', color:'var(--text-muted)', padding:'7px 16px', borderRadius:'7px', cursor:'pointer', fontFamily:'IBM Plex Sans,sans-serif', fontSize:'0.85rem' },
    tabs: { display:'flex', gap:'4px', marginBottom:'24px', borderBottom:'1px solid var(--border)' },
    tab: { background:'none', border:'none', borderBottom:'2px solid transparent', color:'var(--text-muted)', padding:'10px 20px', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', cursor:'pointer', marginBottom:'-1px' },
    tabActivo: { color:'var(--accent)', borderBottomColor:'var(--accent)', fontWeight:'500' },
    tabContent: { display:'flex', flexDirection:'column', gap:'20px' },
    card: { backgroundColor:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', padding:'22px 24px' },
    cardTitulo: { fontSize:'0.95rem', fontWeight:'600', color:'var(--text-primary)', marginBottom:'6px' },
    cardDesc: { fontSize:'0.8rem', color:'var(--text-muted)', marginBottom:'18px', lineHeight:'1.5' },
    form: { display:'flex', flexDirection:'column', gap:'12px' },
    formRow: { display:'flex', gap:'12px', alignItems:'flex-end', flexWrap:'wrap' },
    campo: { display:'flex', flexDirection:'column', gap:'6px', flex:1, minWidth:'160px' },
    label: { fontSize:'0.68rem', color:'var(--text-muted)', letterSpacing:'0.06em', textTransform:'uppercase' },
    input: { padding:'9px 12px', backgroundColor:'var(--bg-base)', border:'1px solid var(--border-light)', borderRadius:'7px', color:'var(--text-primary)', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', outline:'none' },
    btnPrimario: { padding:'9px 20px', backgroundColor:'var(--accent)', color:'white', border:'none', borderRadius:'7px', cursor:'pointer', fontSize:'0.875rem', fontFamily:'IBM Plex Sans,sans-serif', fontWeight:'500', whiteSpace:'nowrap', alignSelf:'flex-end' },
    successBox: { backgroundColor:'rgba(16,196,138,0.08)', border:'1px solid rgba(16,196,138,0.2)', color:'var(--success)', padding:'9px 13px', borderRadius:'7px', fontSize:'0.83rem' },
    errorBox: { backgroundColor:'rgba(240,77,94,0.08)', border:'1px solid rgba(240,77,94,0.2)', color:'var(--danger)', padding:'9px 13px', borderRadius:'7px', fontSize:'0.83rem' },
    tablaWrap: { backgroundColor:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:'12px', overflow:'hidden' },
    tablaHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'14px 20px', borderBottom:'1px solid var(--border)' },
    tablaCount: { fontSize:'0.78rem', color:'var(--text-muted)', fontFamily:'IBM Plex Mono,monospace' },
    tabla: { width:'100%', borderCollapse:'collapse' },
    th: { padding:'10px 14px', textAlign:'left', fontSize:'0.65rem', color:'var(--text-muted)', letterSpacing:'0.08em', textTransform:'uppercase', backgroundColor:'var(--bg-surface)', borderBottom:'1px solid var(--border)', whiteSpace:'nowrap' },
    td: { padding:'11px 14px', fontSize:'0.82rem', color:'var(--text-primary)', borderBottom:'1px solid var(--border)', whiteSpace:'nowrap' },
    tdMono: { fontFamily:'IBM Plex Mono,monospace', color:'var(--text-muted)', fontSize:'0.78rem' },
    tdVacio: { padding:'32px', textAlign:'center', color:'var(--text-dim)', fontSize:'0.875rem' },
    pill: { padding:'2px 9px', borderRadius:'20px', fontSize:'0.72rem', fontWeight:'500', border:'1px solid' },
    pillVerde: { backgroundColor:'rgba(16,196,138,0.1)', color:'var(--success)', borderColor:'rgba(16,196,138,0.25)' },
    pillRojo: { backgroundColor:'rgba(240,77,94,0.1)', color:'var(--danger)', borderColor:'rgba(240,77,94,0.25)' },
    btnAccion: { padding:'4px 12px', borderRadius:'6px', border:'1px solid', cursor:'pointer', fontSize:'0.75rem', fontFamily:'IBM Plex Sans,sans-serif', fontWeight:'500' },
    btnDesactivar: { backgroundColor:'rgba(240,77,94,0.08)', color:'var(--danger)', borderColor:'rgba(240,77,94,0.25)' },
    btnActivar: { backgroundColor:'rgba(16,196,138,0.08)', color:'var(--success)', borderColor:'rgba(16,196,138,0.25)' },
};

export default AdminEmpresa;